/** Company is the client identity used in tables and selectors. */
export function clientLabel(client) {
  if (!client) return '';
  const company = String(client.company_name || '').trim();
  const name = String(client.name || '').trim();
  if (company && name && company.toLowerCase() !== name.toLowerCase()) {
    return `${company} — ${name}`;
  }
  return company || name;
}
